<template>
  <div class="loginFormWrap">
    <SignIn
      v-if="isSignIn"
      @toSignup="isSignIn = false"
    />
    <SignUp
      v-else
      @toSignin="isSignIn = true"
    />
    <div
      v-if="!installedCrx && loginCount > 0 && !$route.query.alibabaOpenUserId"
      class="lockWrap"
    >
      <v-spacer />
      <div>
        <img
          src="../images/yuechi-04.png"
          style="vertical-align: middle;"
        >
      </div>
      <div>
        <img
          src="../images/yuechi-06.png"
          style="vertical-align: middle;width: 240px;margin-top: 30px;"
        >
      </div>
      <!-- <div
        class="orange--text mt-3"
        style="font-size: 18px;">
        「解鎖要靠自己，客服也沒答案」
      </div> -->
      <v-spacer />

      <div>
        <img
          src="../images/yuechi-05.png"
          style="vertical-align: middle;width: 245px;"
        >
      </div>
      <div
        class="text-xs-center py-2"
      >
        <img
          src="../images/appQrcode.png"
          width="60"
        >
      </div>
    </div>
  </div>
</template>
<script>
import SignIn from './SignIn.vue'
import SignUp from './SignUp.vue'
export default {
  props: { standalone: Boolean },
  components: {
    SignIn,
    SignUp
  },
  data () {
    return {
      isSignIn: !(this.standalone && this.$route.query.auth === 'register'),
      loginCount: localStorage.loginCount
    }
  },
  computed: {
    installedCrx () {
      return this.$store.state.installedCrx
    },
  },
}
</script>
<style lang="postcss" scoped>
.loginFormWrap {
  background: rgba(255, 255, 255, 0.8);
  width: 360px;
  padding: 20px 25px;
  z-index: 1;
  position: relative;
  border-radius: 5px;
  .lockWrap {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-direction: column;
    text-align: center;
  }
}
</style>
